import React, { useState } from 'react';
import { FiX, FiMail, FiLock, FiEye, FiEyeOff, FiLoader } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import './LoginModal.scss';

const LoginModal = ({ isOpen, onClose }) => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Limpiar error al escribir
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      setError('Por favor ingresa usuario y contraseña');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const result = await login(formData);

      if (result.success) {
        // Solo clientes pueden acceder al portal
        // Comparación case-insensitive para mayor compatibilidad
        const userRole = result.user?.role?.toLowerCase();

        if (userRole === 'client') {
          // Cerrar modal y recargar el portal en modo autenticado
          onClose();
          setFormData({ username: '', password: '' });
        } else {
          setError('Este portal es solo para clientes. El personal debe usar el login administrativo.');
          setLoading(false);
        }
      } else {
        setError(result.message || 'Credenciales incorrectas');
        setLoading(false);
      }
    } catch (error) {
      setError('Error inesperado. Intenta nuevamente.');
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({ username: '', password: '' });
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={handleClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-modal__close" onClick={handleClose} disabled={loading}>
          <FiX />
        </button>

        <div className="login-modal__header">
          <h2>Iniciar Sesión</h2>
          <p>Accede a tu portal de cliente</p>
        </div>

        <form onSubmit={handleSubmit} className="login-modal__form">
          {error && (
            <div className="login-modal__error">
              {error}
            </div>
          )}

          <div className="login-modal__field">
            <label htmlFor="modal-username" className="login-modal__label">
              Correo electrónico
            </label>
            <div className="login-modal__input-wrapper">
              <FiMail className="login-modal__input-icon" />
              <input
                id="modal-username"
                type="email"
                className="login-modal__input"
                placeholder="tu@email.com"
                value={formData.username}
                onChange={(e) => handleInputChange('username', e.target.value)}
                disabled={loading}
                autoComplete="email"
                autoFocus
              />
            </div>
          </div>

          <div className="login-modal__field">
            <label htmlFor="modal-password" className="login-modal__label">
              Contraseña
            </label>
            <div className="login-modal__input-wrapper">
              <FiLock className="login-modal__input-icon" />
              <input
                id="modal-password"
                type={showPassword ? 'text' : 'password'}
                className="login-modal__input"
                placeholder="Ingresa tu contraseña"
                value={formData.password}
                onChange={(e) => handleInputChange('password', e.target.value)}
                disabled={loading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-modal__toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
                tabIndex="-1"
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="login-modal__submit"
            disabled={loading || !formData.username || !formData.password}
          >
            {loading ? (
              <>
                <FiLoader className="spin" />
                Iniciando sesión...
              </>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>

        <div className="login-modal__footer">
          <p>¿No tienes cuenta? Contacta con tu ejecutivo de ventas</p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
